import ShowBar from './ShowBar';
import './HeadUpDisplay.css';

function HeadUpDisplay({ state, openLogBook, buyHint }) {
  return (
    <>
      <div id='hud'>
        <div className='topbanner'>
          <div className='stats'>
            Claimed: {state.claimedCount}/{state.claimedCount+state.landPoints} | Unexploited: {state.untouchedCount}<br />
            Known advancements: {state.knownAdvancements}/{state.allAdvancements}<br />
            Built advancements: {state.usedAdvancements}/{state.allAdvancements}<br />
            AP generation speed: {Math.round(10000/(100-state.usedAdvancements/state.allAdvancements*75))}%</div>
          { state.landUse === 'Unclaimed' || state.landUse === 'Unexploited'
            ? <div className='hovertext'>{state.landType} - {state.landUse}</div>
            : <div className='hovertext'>{state.landUse} - Combos {state.combinationsFound}/{state.combinationsTotal}, Descendants {state.descendantsFound}/{state.descendantsTotal}</div>
          }
          <div className='logandhint'>
            { state.hintAvailable && <button className={ 'hintbutton' + (state.hintAffordable ? ' enabled' : '') } onClick={buyHint}>Buy hint: {state.hintBuyCost} AP</button> }
            <img alt="Log" title="Log" src={require(`./images/log.svg`).default} onClick={openLogBook} />
          </div>
        </div>
        <div className='middle'>
          <div className='side'><ShowBar name="LP" description="Land Points" value={state.landPoints} max={state.maxLandPoints} hideMax color1="#6c6" color2="#4a4"></ShowBar></div>
          <div className='filler'></div>
          <div className='side'><ShowBar name="AP" description="Advancement Points" nonLinear value={state.advancementPoints} max={state.maxAdvancementPoints} color1="#ca0" color2="#a80" animation='flashyellow'></ShowBar></div>
        </div>
        <div className='bottombanner'>
        </div>
      </div>
    </>
  );
}

export default HeadUpDisplay;
